import React, { FC, useEffect } from 'react';
import Collapse from '@material-ui/core/Collapse';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { VOTE_OPTIONS } from '../../../features/article/ArticleShow/enums/voteOptions';
import Button from '../../form/elements/Button';
import { BUTTON_VARIANT } from '../../form/enum/formProps';

interface ContainerProps {
  open: string;
  className?: string;
  onTimeout: () => void;
  onSelect?: () => void;
}

const Container: FC<ContainerProps> = (props) => {
  const { t } = useTranslation();
  const { onTimeout, open, onSelect, className } = props;
  useEffect(() => {
    if (open === VOTE_OPTIONS.YES || open === VOTE_OPTIONS.NO) {
      setTimeout(() => {
        onTimeout();
      }, 3000);
    }
  }, [open]);
  const handleNoAnswerClick = () => {
    onSelect?.();
  };
  return (
    <div className={className}>
      <Collapse in={open === VOTE_OPTIONS.YES || open === VOTE_OPTIONS.NO}>
        <Box display="flex" flexDirection="column" alignItems="center" gridGap={16} my={7}>
          <Typography variant="h6">{t('article.thanks_for_vote')}</Typography>
          <img width="37" src="/vote_ok.svg" alt="vote ok" />
          <Typography>{t('article.your_feedback_will_help_us')}</Typography>
        </Box>
      </Collapse>
      <Collapse in={open === VOTE_OPTIONS.NO_INFO}>
        <Box display="flex" flexDirection="column" alignItems="center" gridGap={16} my={7}>
          <Typography variant="subtitle1">{t('article.vote_give_feedback')}</Typography>
          <Button
            text={t('article.vote_no_answer')}
            variant={BUTTON_VARIANT.OUTLINED}
            onClick={handleNoAnswerClick}
            className={'answer_no_not_answer AnswerNo'}
          />
          <Button
            text={t('article.vote_incomprehensible')}
            variant={BUTTON_VARIANT.OUTLINED}
            onClick={handleNoAnswerClick}
            className={'answer_no_incomprehensible AnswerNo'}
          />
          <Button
            text={t('article.vote_out_of_date')}
            variant={BUTTON_VARIANT.OUTLINED}
            onClick={handleNoAnswerClick}
            className={'answer_no_out_of_date AnswerNo'}
          />
        </Box>
      </Collapse>
    </div>
  );
};

export default Container;
